import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type OficioSubstituicaoDiretorTecnicoPjJob = ReportJob;
export type OficioSubstituicaoDiretorTecnicoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Ofício de Substituição de Diretor Técnico. */
@Injectable({ providedIn: 'root' })
export class OficioSubstituicaoDiretorTecnicoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'oficio-substituicao-diretor-tecnico-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.oficioSubstituicaoDiretorTecnicoPj;
}
